import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserServiceSDK } from 'ms-user-angular-sdk';

@Component({
    selector: 'app-manage-users-form',
    templateUrl: './manage-users-form.component.html',
    styleUrls: ['./manage-users-form.component.scss']
})
export class ManageUsersFormComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ManageUsersFormComponent>,
        public dialog: MatDialog,
        private userService: UserServiceSDK
      ) { }

    isDataLoading: boolean = true;
    clientUsers: any[] = [];
    notBillableUsers: any[] = [];
    billableUsers: any[] = [];

    counters = {
        billable: 0,
        notBillable: 0,
        changes: 0,
        changesSubmitted: 0
    }

    filterNotBillableUsers: string = '';
    filterBillableUsers: string = '';

    sortableOptions: any = {
        group: 'users',
        ghostClass: 'dragging',
        onEnd: (event: any) => this.onDrop(event)
    };

    changes: Array<boolean> = [];

    canSubmit: boolean = false;
    submitMessage: string = '';

    ngOnInit() {
        this.getClientUsers(this.data.planet);
    }

    getClientUsers = (planet): Promise<void> => {
        return new Promise((resolve) => {
            this.userService.getUsers(planet, 'compact').subscribe(results => {
                this.clientUsers = results;
                this.filterUsers('', true);
                this.filterUsers('', false);
                this.isDataLoading = false;
                resolve();
            });
            }
        );
    }

    filterUsers = (filter: string = '', isBillable: boolean): void => {
        let clientUsers = this.clientUsers.map(user => ({ ...user }));
        if (Object.keys(this.changes).length > 0) {
            clientUsers.forEach(user => {
                if (this.changes[user.email] !== undefined) {
                    user.isBillable = this.changes[user.email];
                }
            });
        }

        const filteredUsers  = clientUsers
            .map(user => user.isBillable === isBillable && user.email.toLowerCase().includes(filter.toLowerCase()) ? { ...user } : null)
            .filter(user => user !== null);

        if (isBillable) {
            this.billableUsers = filteredUsers;
        } else {
            this.notBillableUsers = filteredUsers;
        }
        this.updateCounters();
    }

    updateCounters = (): void => {
        this.counters.billable = this.billableUsers.length;
        this.counters.notBillable = this.notBillableUsers.length;
    }

    onDrop = (event: any): void => {
        const userEmail = event.item.innerText.trim();
        const newIsBillable = (event.to.dataset.usersList === 'billable');
        const isAChange = this.clientUsers.find(user => user.email === userEmail).isBillable !== newIsBillable;
        if (isAChange) {
            this.changes[userEmail] = (event.to.dataset.usersList === 'billable');
        } else if (this.changes[userEmail] !== undefined) {
            delete this.changes[userEmail];
        }

        this.canSubmit = Object.keys(this.changes).length > 0;
    }

    submitChanges = async (): Promise<void> => {
        this.counters.changes = Object.keys(this.changes).length;
        this.counters.changesSubmitted = 0;
        let failedSubmissions = [];
        const keys = Object.keys(this.changes);
        for (let index = 0; index < keys.length; index++) {
          const email = keys[index];
          this.counters.changesSubmitted++;
          this.submitMessage = `Changing ${email} to ${this.changes[email] ? 'billable' : 'not billable'}`;
          try {
            const userId = this.clientUsers.find(user => user.email === email).id;
            await this.userService.changeBillableUser(userId, this.changes[email] ? 'true' : 'false').toPromise();
            await new Promise(resolve => setTimeout(resolve, 2000));
          } catch (error) {
            failedSubmissions.push(email);
          }
        }
        this.submitMessage = 'All changes submitted.';
        if (failedSubmissions.length > 0) {
            this.submitMessage += ` Failed to change ${failedSubmissions.join(', ')}. Please try submitting them again after reopening the dialog or contact a supervisor.`;
        } else {
            this.submitMessage += ' Refreshing data in 3 seconds.';
            this.changes = [];
            this.canSubmit = false;
            this.filterBillableUsers = '';
            this.filterNotBillableUsers = '';
            setTimeout(() => {
              this.submitMessage = '';
              this.getClientUsers(this.data.planet);
            }, 3000);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/forms/manage-users-form/manage-users-form.component.ts